import { Component, Inject, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PosterListComponent } from 'src/app/shared/components/poster-list/poster-list.component';
import { TryAndBookComponent } from 'src/app/shared/components/try-and-book/try-and-book.component';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { MetaTagsService } from 'projects/qo-commons/src/services/meta-tags/meta-tags.service';
import { CustomerStory } from 'src/app/shared/components/customer-story/customer-story.data';
import { CustomerStoryComponent } from 'src/app/shared/components/customer-story/customer-story.component';

@Component({
    selector: 'app-cyclisme-piste',
    imports: [CommonModule, RouterModule, TryAndBookComponent, PosterListComponent, CustomerStoryComponent],
    templateUrl: './cyclisme-piste.component.html'
})
export class CyclismePisteComponent {
  NavigationService = NavigationService;

  assetsPath = "assets/images/success-stories/cyclisme-piste/";
  
  customerStory: CustomerStory = {
    webp_photo_url: this.assetsPath + 'aude-lefort-coordinatrice-piste-cyclisme-piste.webp',
    photo_url: this.assetsPath + 'aude-lefort-coordinatrice-piste-cyclisme-piste.jpg',
    description: $localize`Au final, on a enregistré un gain de temps dans le recrutement, la planification, la formation et une rationalisation du budget, non négligeable pour un organisateur, tout en améliorant la qualité du programme bénévoles.`,
    logo_url: this.assetsPath + 'uci-cyclisme-sur-piste.png',
    dark_logo_url: this.assetsPath + 'uci-cyclisme-sur-piste.png',
    customer_name: "Aude Lefort",
    customer_role: $localize`Coordinatrice épreuve piste`,
    types: []
  }
  
  qoCustomerStory: CustomerStory = {
    webp_photo_url: this.assetsPath + 'hugo-charge-projet-evenement.webp',
    photo_url: this.assetsPath + 'hugo-charge-projet-evenement.jpg',
    description: $localize`L'organisation de cette deuxième édition a été grandement simplifiée grâce à la fonctionnalité de duplication d'événement de Qoezion, ce qui en fait un exemple parfait pour illustrer son efficacité. De plus, nous avons pu mobiliser la communauté déjà inscrite l'année précédente, ce qui démontre la fidélisation des bénévoles d'une année sur l'autre et leur connaissance des missions de l'événement.`,
    logo_url: this.assetsPath + 'logo-quick-off.svg',
    dark_logo_url: this.assetsPath + 'logo-quick-off.svg',
    customer_name: "Hugo Fouet",
    customer_role: $localize`Coordinateur événementiel`,
    types: []
  }

  constructor(private metaTagsService: MetaTagsService, @Inject(LOCALE_ID) public locale: string) {}

  ngAfterViewChecked() {
      this.metaTagsService.setSeoSettings({
          title: $localize`L'expertise de Quick-Off dans la gestion bénévoles des Championnats du Monde de Cyclisme sur Piste`,
          description: $localize`Notre expertise technique avec Qoezion et l'expérience sur le terrain de nos équipes se sont combinées pour créer une harmonie dans la gestion des bénévoles, garantissant ainsi le succès de l'événement.`,
          imageUrl: `assets/images/success-stories/quickoff-customers.${this.locale}.jpg`
      });
  }
}
